import { LogError, LogWarning } from "../../../helpers/logger"

export default function RefGetErrorMessage(error) {
  let errorHeader = "Error"
  let errorDetail = ""
  if (error.isAxiosError) {
    LogError(error)

    if (error.response) {
      const { data, status } = error.response

      errorHeader = status.toString()

      switch (status) {
        case 400:
          if (data.errors) {
            const processedErrors = []
            for (const key in data.errors) {
              if (data.errors[key]) {
                processedErrors.push(data.errors[key])
              }
            }
            errorDetail = processedErrors.join("\n")
          } else {
            errorDetail = data
          }

          break
        case 401:
          errorHeader = "unauthorised action"
          errorDetail = "The user is not authorised to do this"
          LogWarning("The user is not authorised")

          break
        case 404:
          errorDetail = "Not found"

          break
        case 500:
          errorHeader = "An unexpected error occurred"
          errorDetail = error.message
          break
        default:
          errorHeader = "An unexpected error occurred"
          errorDetail = error.message
      }
    } else {
      errorDetail = error.message
    }
  } else {
    errorDetail = error.message
  }

  return `${errorHeader}: ${errorDetail}`
}
